/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** VisitStatusEnum */
export enum VisitStatusEnum {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/** TransportModeEnum */
export enum TransportModeEnum {
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE',
  PUBLIC_TRANSIT = 'PUBLIC_TRANSIT',
}

/** RequestStatusEnum */
export enum RequestStatusEnum {
  SUBMITTED = 'SUBMITTED',
  UNFULFILLED = 'UNFULFILLED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

/** PaymentMethod */
export enum PaymentMethod {
  Cash = 'cash',
  Card = 'card',
}

/**
 * NoteRoleEnum
 * A role code as ``notes.author_role`` and ``notes.audience`` spell it.
 *
 * The same four codes ``app.entity_role`` carries, so an RLS predicate is a
 * literal ``= ANY(audience)``. ``ofa`` is deliberately absent: an office
 * administrator's session runs as ``adm`` (see
 * ``homecare.utils.request_context.ADMIN_DATA_ROLES``), so a note it writes is
 * authored by ``adm`` and the CHECK constraint would refuse anything else.
 */
export enum NoteRoleEnum {
  Adm = 'adm',
  Cgv = 'cgv',
  Doc = 'doc',
  Clt = 'clt',
}

/**
 * NoteKindEnum
 * What a ``notes`` row is, mirroring ``enum_note_kind``.
 *
 * ``VISIT_NOTE`` is a record about the work; ``MESSAGE`` is addressed to
 * someone and is the only kind that notifies. The distinction is NOT who may
 * read the row - that is ``audience``.
 */
export enum NoteKindEnum {
  VISIT_NOTE = 'VISIT_NOTE',
  MESSAGE = 'MESSAGE',
}

/** MobilityEnum */
export enum MobilityEnum {
  INDEPENDENT = 'INDEPENDENT',
  INDEPENDENT_WITH_ASSISTIVE_DEVICE = 'INDEPENDENT_WITH_ASSISTIVE_DEVICE',
  ASSISTED = 'ASSISTED',
  WHEELCHAIR = 'WHEELCHAIR',
  BEDBOUND = 'BEDBOUND',
}

/** GenderEnum */
export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

/** DoctorTypeEnum */
export enum DoctorTypeEnum {
  ATTENDING = 'ATTENDING',
  REFERRING = 'REFERRING',
}

/** DoctorInstructionStatus */
export enum DoctorInstructionStatus {
  PROCESSING = 'PROCESSING',
  HANDLED = 'HANDLED',
  NOT_HANDLED = 'NOT_HANDLED',
}

/** DoctorInstructionPriority */
export enum DoctorInstructionPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
}

/**
 * DoctorCommentVisibility
 * Who may read the comment.
 *
 * ``MEDICAL_ONLY`` is withheld from the caregiver by RLS, not by the query -
 * the column exists precisely so that decision does not depend on whoever
 * writes the next SELECT.
 */
export enum DoctorCommentVisibility {
  CARE_TEAM = 'CARE_TEAM',
  MEDICAL_ONLY = 'MEDICAL_ONLY',
}

/** ContactTypeEnum */
export enum ContactTypeEnum {
  EMERGENCY = 'EMERGENCY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

/**
 * CollectUnit
 * Mirror of ``enum_collect_unit``.
 *
 * ``MONTHS`` is a CALENDAR month, not 30 days - a monthly collection that
 * drifts two days a quarter is not a monthly collection. The arithmetic in
 * ``homecare.payments.collection`` walks calendar months for that reason.
 */
export enum CollectUnit {
  Visits = 'visits',
  Days = 'days',
  Months = 'months',
}

/**
 * CollectTiming
 * Mirror of ``enum_collect_timing``: which visit of a period collects.
 *
 * ``FIRST_VISIT`` is paid upfront, ``LAST_VISIT`` after the service. NULL in the
 * database reads as ``LAST_VISIT``, which is what every row did before this existed.
 */
export enum CollectTiming {
  FirstVisit = 'first_visit',
  LastVisit = 'last_visit',
}

/**
 * CollectAnchor
 * Mirror of ``enum_collect_anchor``: how a MONTHS cadence cuts its periods.
 *
 * Since 20260928120000 every unit uses fixed periods (see
 * ``homecare.payments.collection``). Two values still change the arithmetic,
 * whatever the unit, because that is what they always meant:
 * ``PER_VISIT`` makes every visit its own period, and ``DAY_OF_MONTH`` runs
 * N-month periods from day X to the day before X (X in
 * ``Cadence.collect_anchor_day``). ``PERIOD_START``/``PERIOD_END``/``None`` mean
 * groups of N visits, N-day blocks or N calendar months.
 */
export enum CollectAnchor {
  PeriodStart = 'period_start',
  PeriodEnd = 'period_end',
  PerVisit = 'per_visit',
  DayOfMonth = 'day_of_month',
}

/** CaregiverPaymentType */
export enum CaregiverPaymentType {
  CostBased = 'cost_based',
  Hourly = 'hourly',
  Salary = 'salary',
}

/**
 * CaregiverNoteFlagEnum
 * How a caregiver's visit note should be read.
 *
 * Mirrors ``visits.caregiver_note_flag``. There is deliberately no member for
 * "unclassified": that is the column's NULL, and an unflagged note is not a
 * ROUTINE one - nothing has judged it yet.
 */
export enum CaregiverNoteFlagEnum {
  ATTENTION = 'ATTENTION',
  INFO = 'INFO',
  ROUTINE = 'ROUTINE',
}

/**
 * AttachmentKindEnum
 * What an attached file is, for the client folder's filters.
 *
 * Mirrors ``attachments.kind``. NULL there means unclassified, so callers
 * bucket those files by content type rather than picking a kind for them.
 */
export enum AttachmentKindEnum {
  REPORT = 'REPORT',
  PHOTO = 'PHOTO',
  LAB = 'LAB',
  PRESCRIPTION = 'PRESCRIPTION',
  INVOICE = 'INVOICE',
  CARE_PLAN = 'CARE_PLAN',
}

/** AddVisitService */
export interface AddVisitService {
  /** Serviceid */
  serviceId: number;
  /** Notes */
  notes?: string | null;
  /** Iscompleted */
  isCompleted?: boolean | null;
  /** Cost */
  cost: number;
  /** Price */
  price: number;
}

/** AttachmentBase */
export interface AttachmentBase {
  /** Attachmentid */
  attachmentId: number;
  /** Filename */
  filename: string;
  /** Contenttype */
  contentType?: string | null;
  /**
   * Uploadedat
   * @format date-time
   */
  uploadedAt: string;
  /** Description */
  description?: string | null;
  /** Thumbnail */
  thumbnail?: string | null;
  kind?: AttachmentKindEnum | null;
}

/** AttachmentCreateResponse */
export interface AttachmentCreateResponse {
  /** Attachmentid */
  attachmentId: number;
}

/**
 * AttachmentUpdate
 * What may be changed about a file after it has been uploaded.
 *
 * The bytes are immutable: replacing a file's content is a new upload, so what is
 * editable is how it is described. Both fields are optional and the routers write
 * only the ones the caller actually sent - `exclude_unset` - so clearing a kind is
 * `{"kind": null}` and leaving it alone is omitting the key. Without that
 * distinction, correcting a description would silently drop the kind.
 */
export interface AttachmentUpdate {
  kind?: AttachmentKindEnum | null;
  /** Description */
  description?: string | null;
}

/** AttachmentWithContent */
export interface AttachmentWithContent {
  /** Attachmentid */
  attachmentId: number;
  /** Filename */
  filename: string;
  /** Contenttype */
  contentType?: string | null;
  /**
   * Uploadedat
   * @format date-time
   */
  uploadedAt: string;
  /** Description */
  description?: string | null;
  /** Thumbnail */
  thumbnail?: string | null;
  kind?: AttachmentKindEnum | null;
  /**
   * Content
   * Base64-encoded file content
   */
  content?: string | null;
  /** Visitid */
  visitId?: number | null;
}

/** Body_createVisitAttachment */
export interface BodyCreateVisitAttachment {
  /**
   * File
   * @format binary
   */
  file: File;
  /**
   * Description
   * Optional description of the attachment
   */
  description?: string | null;
  /** What the file is, for the client folder's filters. Omit to leave it unclassified. */
  kind?: AttachmentKindEnum | null;
}

/** Caregiver */
export interface Caregiver {
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Userid */
  userId?: number | null;
  /** Enabled */
  enabled?: boolean | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  transportMode?: TransportModeEnum | null;
  /**
   * Services
   * @minLength 1
   */
  services: number[] | ServiceDb[];
  /** Certifications */
  certifications?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Hourlyrate */
  hourlyRate?: number | null;
  /** @default "cost_based" */
  paymentType?: CaregiverPaymentType;
  /** Monthlysalary */
  monthlySalary?: number | null;
  /** Rating */
  rating?: number | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Caregiverid */
  caregiverId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/** CaregiverAvailabilityResponse */
export interface CaregiverAvailabilityResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** CaregiverServiceRequestResponse */
export interface CaregiverServiceRequestResponse {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
}

/** CaregiverWithServices */
export interface CaregiverWithServices {
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Userid */
  userId?: number | null;
  /** Enabled */
  enabled?: boolean | null;
  /** Caregivergroupid */
  caregiverGroupId?: number | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Travelradiuskm */
  travelRadiusKm?: number | null;
  /** Coverageareas */
  coverageAreas?: string[] | null;
  transportMode?: TransportModeEnum | null;
  /**
   * Services
   * @minItems 1
   */
  services: ServiceDb[];
  /** Certifications */
  certifications?: string[] | null;
  /** Skills */
  skills?: string[] | null;
  /** Specialties */
  specialties?: string[] | null;
  /** Languagesspoken */
  languagesSpoken?: string[] | null;
  /** Hourlyrate */
  hourlyRate?: number | null;
  /** @default "cost_based" */
  paymentType?: CaregiverPaymentType;
  /** Monthlysalary */
  monthlySalary?: number | null;
  /** Rating */
  rating?: number | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /** Caregiverid */
  caregiverId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/**
 * ChangedCaregiverView
 * One caregiver on one side of a staffing row, named for display.
 */
export interface ChangedCaregiverView {
  /** Caregiverid */
  caregiverId: number;
  /** Name */
  name: string;
}

/**
 * ClientContact
 * Model for client contact returned from database
 */
export interface ClientContact {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Relationship */
  relationship?: string | null;
  contactType: ContactTypeEnum;
  /** Notes */
  notes?: string | null;
  /** Clientcontactid */
  clientContactId: number;
  /** Clientid */
  clientId: number;
}

/**
 * ClientDoctorInClient
 * Client doctor info returned within client (with populated doctor details)
 */
export interface ClientDoctorInClient {
  /** Clientdoctorid */
  clientDoctorId: number;
  /** Doctorid */
  doctorId: number;
  doctorType: DoctorTypeEnum;
  /**
   * Startdate
   * @format date
   */
  startDate: string;
  /** Enddate */
  endDate?: string | null;
  /**
   * Takescommission
   * @default true
   */
  takesCommission?: boolean;
  /** Commissionrate */
  commissionRate?: number | null;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Doctorfirstname */
  doctorFirstName?: string | null;
  /** Doctorlastname */
  doctorLastName?: string | null;
  /** Doctoremail */
  doctorEmail?: string | null;
  /** Doctorphonemobile */
  doctorPhoneMobile?: string | null;
  /** Doctorspecialization */
  doctorSpecialization?: string | null;
}

/** ClientMinified */
export interface ClientMinified {
  /** Clientid */
  clientId: number | null;
  /** Firstname */
  firstName?: string | null;
  /** Lastname */
  lastName?: string | null;
  /** City */
  city?: string | null;
  /** Street */
  street?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
}

/**
 * ClientServiceRequestResponse
 * Client with service request details
 */
export interface ClientServiceRequestResponse {
  /** Clientid */
  clientId: number;
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
}

/**
 * ClientWithDoctors
 * Client model with populated doctor information for visits
 */
export interface ClientWithDoctors {
  /**
   * Firstname
   * @minLength 1
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 1
   */
  lastName: string;
  /** Dateofbirth */
  dateOfBirth?: string | null;
  gender?: GenderEnum | null;
  /** Nationalid */
  nationalId?: string | null;
  /** Socialsecurityid */
  socialSecurityId?: string | null;
  /** Phonemobile */
  phoneMobile?: string | null;
  /** Phonehome */
  phoneHome?: string | null;
  /** Email */
  email?: string | null;
  /** Userid */
  userId?: number | null;
  /** Street */
  street?: string | null;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  /** Medicalhistory */
  medicalHistory?: string | null;
  /** Medications */
  medications?: string[] | null;
  /** Allergies */
  allergies?: string[] | null;
  mobility?: MobilityEnum | null;
  /** Preferredlanguage */
  preferredLanguage?: string | null;
  /** Favoritecaregivers */
  favoriteCaregivers?: number[] | null;
  /**
   * Categoryids
   * @default []
   */
  categoryIds?: number[];
  /** Notes */
  notes?: string | null;
  /**
   * Active
   * @default true
   */
  active?: boolean;
  /**
   * Deceased
   * @default false
   */
  deceased?: boolean;
  /** Clientid */
  clientId: number;
  /** Createdat */
  createdAt?: string | null;
  /** Updatedat */
  updatedAt?: string | null;
  /** Contacts */
  contacts?: ClientContact[] | null;
  /** Doctors */
  doctors?: ClientDoctorInClient[] | null;
  referringDoctor?: DoctorMinified | null;
  attendingDoctor?: DoctorMinified | null;
}

/**
 * DoctorComment
 * A doctor's care-team comment, as the portal has always returned it.
 *
 * The shape is unchanged; what backs it is not. `visit_doctor_comments` is gone
 * and a comment is a MESSAGE row in `notes`, so `comment_id` is a note id and
 * `visibility` is derived from the note's `audience` - CARE_TEAM is the array
 * with 'cgv' in it.
 */
export interface DoctorComment {
  /** Commentid */
  commentId: number;
  /** Visitid */
  visitId: number;
  /** Doctorid */
  doctorId?: number | null;
  /** Body */
  body: string;
  /**
   * Who may read the comment.
   *
   * ``MEDICAL_ONLY`` is withheld from the caregiver by RLS, not by the query -
   * the column exists precisely so that decision does not depend on whoever
   * writes the next SELECT.
   */
  visibility: DoctorCommentVisibility;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Doctorname */
  doctorName?: string | null;
}

/** DoctorCommentCreate */
export interface DoctorCommentCreate {
  /**
   * Body
   * @minLength 1
   * @maxLength 4000
   */
  body: string;
}

/** DoctorCommentUpdate */
export interface DoctorCommentUpdate {
  /** Body */
  body?: string | null;
}

/** DoctorInstruction */
export interface DoctorInstruction {
  /** Instructionid */
  instructionId: number;
  /** Visitid */
  visitId: number;
  /** Clientid */
  clientId?: number | null;
  /** Clientfirstname */
  clientFirstName?: string | null;
  /** Clientlastname */
  clientLastName?: string | null;
  /** Doctorid */
  doctorId: number;
  /** Serviceid */
  serviceId?: number | null;
  /** Title */
  title: string;
  /** Details */
  details?: string | null;
  priority: DoctorInstructionPriority;
  status: DoctorInstructionStatus;
  /** Decidedby */
  decidedBy?: number | null;
  /** Decidedat */
  decidedAt?: string | null;
  /** Decisionnote */
  decisionNote?: string | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
}

/** DoctorInstructionCreate */
export interface DoctorInstructionCreate {
  /** Visitid */
  visitId: number;
  /**
   * Title
   * @minLength 1
   * @maxLength 300
   */
  title: string;
  /** Serviceid */
  serviceId?: number | null;
  /** Details */
  details?: string | null;
  /** @default "NORMAL" */
  priority?: DoctorInstructionPriority;
}

/**
 * DoctorInstructionDecision
 * The office's answer. HANDLED or NOT_HANDLED, never back to PROCESSING.
 */
export interface DoctorInstructionDecision {
  status: DoctorInstructionStatus;
  /** Decisionnote */
  decisionNote?: string | null;
}

/**
 * DoctorInstructionUpdate
 * A doctor correcting their own instruction. Status is not settable here.
 *
 * Deciding is a different operation with a different actor, so it has its own
 * model rather than an optional field somebody could pass by accident.
 */
export interface DoctorInstructionUpdate {
  /** Title */
  title?: string | null;
  /** Serviceid */
  serviceId?: number | null;
  /** Details */
  details?: string | null;
  priority?: DoctorInstructionPriority | null;
}

/**
 * DoctorMinified
 * Minimal doctor info for client display
 */
export interface DoctorMinified {
  /** Doctorid */
  doctorId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * Note
 * One note as it is read back.
 *
 * Flat rather than nested: the author is three sibling fields, not an object.
 * Two of them can be absent and the third never is, which is the shape the
 * data actually has - a nested object would have to exist with every field
 * null for a migrated legacy row.
 */
export interface Note {
  /** Noteid */
  noteId: number;
  /** Clientid */
  clientId: number;
  /** Visitid */
  visitId?: number | null;
  /**
   * What a ``notes`` row is, mirroring ``enum_note_kind``.
   *
   * ``VISIT_NOTE`` is a record about the work; ``MESSAGE`` is addressed to
   * someone and is the only kind that notifies. The distinction is NOT who may
   * read the row - that is ``audience``.
   */
  kind: NoteKindEnum;
  /** Authoruserid */
  authorUserId?: number | null;
  /**
   * A role code as ``notes.author_role`` and ``notes.audience`` spell it.
   *
   * The same four codes ``app.entity_role`` carries, so an RLS predicate is a
   * literal ``= ANY(audience)``. ``ofa`` is deliberately absent: an office
   * administrator's session runs as ``adm`` (see
   * ``homecare.utils.request_context.ADMIN_DATA_ROLES``), so a note it writes is
   * authored by ``adm`` and the CHECK constraint would refuse anything else.
   */
  authorRole: NoteRoleEnum;
  /** Authorname */
  authorName?: string | null;
  /** Audience */
  audience: NoteRoleEnum[];
  /** Body */
  body: string;
  flag?: CaregiverNoteFlagEnum | null;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /**
   * Isread
   * @default false
   */
  isRead?: boolean;
}

/** PaginatedResponse[DoctorInstruction] */
export interface PaginatedResponseDoctorInstruction {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: DoctorInstruction[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PaginatedResponse[Note] */
export interface PaginatedResponseNote {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: Note[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PaginatedResponse[VisitNote] */
export interface PaginatedResponseVisitNote {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: VisitNote[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** PaymentContext */
export interface PaymentContext {
  /** Cadenceactive */
  cadenceActive: boolean;
  /** Paymentrequired */
  paymentRequired: boolean;
  /**
   * Outstandingamount
   * @default 0
   */
  outstandingAmount?: number;
  /** Totalcharged */
  totalCharged?: number | null;
  /** Totalpaid */
  totalPaid?: number | null;
  /** Paidatvisit */
  paidAtVisit?: number | null;
  /** Clientoutstandingamount */
  clientOutstandingAmount?: number | null;
  /**
   * Iscollectionvisit
   * @default false
   */
  isCollectionVisit?: boolean;
  defaultPaymentMethod?: PaymentMethod | null;
  unpaidPrevious?: UnpaidPrevious | null;
}

/**
 * PlanningSessionChangeView
 * One changed visit, and the at-most-two groups that changed on it.
 *
 * A ``null`` group has not net-changed and produces no row in the panel. A visit
 * with both groups ``null`` is not in the response at all.
 */
export interface PlanningSessionChangeView {
  /** Visitid */
  visitId: number;
  /** Clientname */
  clientName: string;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  staffing?: StaffingChangeView | null;
  timing?: TimingChangeView | null;
  /** Contested */
  contested: boolean;
}

/**
 * PlanningSessionFlushView
 * What pressing Complete actually sent.
 *
 * ``published`` exists because the three counts cannot tell the two zero cases
 * apart: "everyone was already up to date, so nothing needed saying" and "every
 * single send failed" are both ``0, 0, 0``. The second one deliberately leaves
 * the session OPEN for the sweep to retry, so it is not a 5xx - the server did
 * what it meant to do - but a client that cannot see it resolves its mutation,
 * refetches, watches the bar reappear, and tells the planner nothing.
 */
export interface PlanningSessionFlushView {
  /** Caregiversnotified */
  caregiversNotified: number;
  /** Adminsnotified */
  adminsNotified: number;
  /** Changes */
  changes: number;
  /** Published */
  published: boolean;
}

/**
 * PlanningSessionView
 * A session as the dashboard needs it.
 *
 * The added fields are all things the frontend must not work out for itself:
 * the quiet-hours rule (see the module docstring) and two counts, which are the
 * honest signal that the silence is deliberate rather than a broken
 * notification pipeline.
 *
 * TWO COUNTS, DELIBERATELY, because the bar and the publish confirmation ask
 * different questions and the answers legitimately differ. See each field.
 */
export interface PlanningSessionView {
  /** Planningsessionid */
  planningSessionId: number;
  /** Userid */
  userId: number;
  /**
   * Startedat
   * @format date-time
   */
  startedAt: string;
  /**
   * Expiresat
   * @format date-time
   */
  expiresAt: string;
  /** Closedat */
  closedAt?: string | null;
  /** Closedby */
  closedBy?: 'planner' | 'expiry' | null;
  /**
   * Deliversat
   * @format date-time
   */
  deliversAt: string;
  /** Pendingchangecount */
  pendingChangeCount: number;
  /** Pendingnotifycount */
  pendingNotifyCount: number;
  /** Timezone */
  timezone: string;
}

/**
 * RecordPaymentRequest
 * Body for POST /visits/{id}/payment.
 */
export interface RecordPaymentRequest {
  /** Amount */
  amount: number | string;
  paymentMethod: PaymentMethod;
  /** Note */
  note?: string | null;
}

/** SendRecipient */
export interface SendRecipient {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Recipienttype */
  recipientType: 'client' | 'caregiver' | 'admin' | 'custom';
}

/** SendResult */
export interface SendResult {
  /** Recipientemail */
  recipientEmail: string;
  /** Status */
  status: 'sent' | 'failed';
  /** Error */
  error?: string | null;
}

/** SendSummaryRequest */
export interface SendSummaryRequest {
  /**
   * Recipients
   * @minItems 1
   */
  recipients: SendRecipient[];
}

/** SendSummaryResponse */
export interface SendSummaryResponse {
  /** Results */
  results: SendResult[];
}

/**
 * ServiceDb
 * Model representing the DB schema of a homecare service.
 */
export interface ServiceDb {
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Servicetypeid
   * ID of the service type (foreign key to ServiceType table)
   */
  serviceTypeId: number;
  /**
   * Estimatedtimeminutes
   * Estimated time required to perform the service in minutes
   * @default 0
   */
  estimatedTimeMinutes?: number | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
  /**
   * Isexternalservice
   * Whether service is provided by a third party
   * @default false
   */
  isExternalService?: boolean;
  /**
   * Commissionexempt
   * Whether service is excluded from commission calculation (e.g., materials, medications)
   * @default false
   */
  commissionExempt?: boolean;
  /**
   * Isactive
   * Whether the service can be selected on new work. An inactive service is retired rather than deleted: it stops appearing in pickers but stays visible on the service requests and visits that already reference it, so history is preserved. Deleting instead would fail anyway - service_request_services and visit_services hold FKs with no cascade.
   * @default true
   */
  isActive?: boolean;
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
}

/**
 * ServiceRequestResponse
 * Model for service requests response body
 */
export interface ServiceRequestResponse {
  /**
   * Fromdate
   * @format date-time
   */
  fromDate: string;
  /**
   * Todate
   * @format date-time
   */
  toDate: string;
  /** Notes */
  notes?: string | null;
  /** Rrule */
  rrule?: string | null;
  status: RequestStatusEnum;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  paymentMethod?: PaymentMethod | null;
  /** Collecteveryn */
  collectEveryN?: number | null;
  collectUnit?: CollectUnit | null;
  /** Where a collection period starts. Omit for the pre-phase-5 behaviour: collectEveryN units measured from the earliest unpaid charge, with no calendar alignment. */
  collectAnchor?: CollectAnchor | null;
  /**
   * Collectanchorday
   * Day of month a 'day_of_month' anchored period starts on. 1..28 only: the 31st is not a day of February, and clamping it would make the collection date depend on the month. Month-end is the 'period_end' anchor, which is exact.
   */
  collectAnchorDay?: number | null;
  /** Which visit of each collection period collects: 'first_visit' (upfront) or 'last_visit' (after the service). Omitted = last_visit. */
  collectTiming?: CollectTiming | null;
  /** Servicerequestid */
  serviceRequestId: number;
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Client with service request details */
  client: ClientServiceRequestResponse;
  preferredCaregiver?: CaregiverServiceRequestResponse | null;
  /** Services */
  services: ServiceServiceRequestResponse[];
  /**
   * Costtotal
   * Cost of the service in Euros
   */
  costTotal?: number | null;
  /**
   * Pricetotal
   * Price of the service in Euros
   */
  priceTotal?: number | null;
  /**
   * Pricefinal
   * Price final for the service request
   */
  priceFinal?: number | null;
  /**
   * Visitcount
   * Number of visits attached to this service request
   * @default 0
   */
  visitCount?: number;
  /**
   * Linecount
   * Number of service-request lines on this service request
   * @default 0
   */
  lineCount?: number;
  /**
   * Packagenames
   * Names of the packages this request's lines were sold from
   */
  packageNames?: string[];
  /**
   * Cancelreason
   * Why the request was cancelled. Always present on a CANCELLED request (chk_sr_cancel_reason_present), NULL otherwise.
   */
  cancelReason?: string | null;
  /**
   * Cancelledat
   * When the request was cancelled. Best-effort rather than guaranteed: requests cancelled before this column existed carry a backfilled timestamp, and no constraint ties it to the status.
   */
  cancelledAt?: string | null;
}

/**
 * ServiceServiceRequestResponse
 * Response model for service data in service requests.
 */
export interface ServiceServiceRequestResponse {
  /**
   * Serviceid
   * Unique identifier for the service (PK of services table)
   */
  serviceId: number;
  /**
   * Name
   * Name of the specific service
   */
  name: string;
  /**
   * Description
   * Detailed description of the service offering
   */
  description?: string | null;
  /**
   * Cost
   * Cost of the service in Euros
   */
  cost?: number | null;
  /**
   * Price
   * Price of the service in Euros
   */
  price?: number | null;
}

/**
 * StaffingChangeView
 * A visit's caregiver set, before and after.
 *
 * An empty list is an unassigned visit. It stays an empty list rather than
 * acquiring a placeholder member: "Unassigned" is a display of absence, and
 * inventing a value for it here would put it on the wire as if it were one.
 */
export interface StaffingChangeView {
  /** From */
  from: ChangedCaregiverView[];
  /** To */
  to: ChangedCaregiverView[];
}

/** SuggestedVisitGroup */
export interface SuggestedVisitGroup {
  /**
   * Date
   * Date of the visit
   * @format date
   */
  date: string;
  /**
   * Starttime
   * Visit start datetime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * Visit end datetime
   * @format date-time
   */
  endTime: string;
  /**
   * Caregivers
   * Caregivers available for this slot
   */
  caregivers: Caregiver[];
}

/** SuggestedVisitsRequest */
export interface SuggestedVisitsRequest {
  /**
   * Dates
   * List of dates for which to schedule visits. The time_slot datetime values will be applied to each of these dates (using the date component from the datetime, but filtering by these specific dates).
   */
  dates: string[];
  /** Time range for each visit as timezone-aware datetimes (e.g. 2025-10-15T09:00:00+02:00 to 2025-10-15T10:00:00+02:00). The time component will be extracted and applied to each date in 'dates'. */
  timeSlot: TimeSlotRequest;
  /**
   * Serviceids
   * Only suggest caregivers who offer these services
   */
  serviceIds?: number[] | null;
  /**
   * Caregiverids
   * Only include caregivers from this list
   */
  caregiverIds?: number[] | null;
  /**
   * Enabledonly
   * Only include enabled caregivers in suggestions
   */
  enabledOnly?: boolean;
  /**
   * Activeonly
   * Only include active caregivers in suggestions
   */
  activeOnly?: boolean;
}

/** TimeSlotRequest */
export interface TimeSlotRequest {
  /**
   * Starttime
   * Start time as timezone-aware datetime
   * @format date-time
   * @example "2025-10-15T09:00:00+02:00"
   */
  startTime: string;
  /**
   * Endtime
   * End time as timezone-aware datetime
   * @format date-time
   * @example "2025-10-15T10:00:00+02:00"
   */
  endTime: string;
}

/**
 * TimingChangeView
 * A visit's start and end, before and after.
 *
 * Both ends on both sides even when only one moved, because a revert is one
 * ``PUT /visits/{id}`` carrying both - see ``TimingChange``.
 */
export interface TimingChangeView {
  /**
   * Fromstart
   * @format date-time
   */
  fromStart: string;
  /**
   * Fromend
   * @format date-time
   */
  fromEnd: string;
  /**
   * Tostart
   * @format date-time
   */
  toStart: string;
  /**
   * Toend
   * @format date-time
   */
  toEnd: string;
}

/** UnpaidPrevious */
export interface UnpaidPrevious {
  /** Visitid */
  visitId: number;
  /** Amount */
  amount: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/**
 * VisitAssignmentRejectionRequest
 * Body of POST /visits/{visit_id}/assignment-rejection.
 *
 * Reject only. There is no accept - the app has never offered one and silence is
 * assent - so this carries no action field and no two-valued enum.
 */
export interface VisitAssignmentRejectionRequest {
  /** Reason */
  reason?: string | null;
}

/** VisitAssignmentRejectionResponse */
export interface VisitAssignmentRejectionResponse {
  /** Visitid */
  visitId: number;
  /**
   * Rejectedat
   * @format date-time
   */
  rejectedAt: string;
  /** Adminsnotified */
  adminsNotified: number;
}

/** VisitAttachmentsPaginatedResponse */
export interface VisitAttachmentsPaginatedResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: AttachmentBase[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** VisitBatchDeleteItemResult */
export interface VisitBatchDeleteItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'deleted' | 'not_found';
  /** Detail */
  detail?: string | null;
}

/** VisitBatchDeleteResponse */
export interface VisitBatchDeleteResponse {
  /**
   * Requestedcount
   * Number of visit IDs requested
   */
  requestedCount: number;
  /**
   * Deletedcount
   * Number of visits successfully deleted
   */
  deletedCount: number;
  /**
   * Notfoundcount
   * Number of visit IDs not found
   */
  notFoundCount: number;
  /**
   * Results
   * Per-visit deletion result
   */
  results: VisitBatchDeleteItemResult[];
}

/** VisitBatchIdsRequest */
export interface VisitBatchIdsRequest {
  /**
   * Visitids
   * List of visit IDs to process
   * @minItems 1
   */
  visitIds: number[];
}

/** VisitBillingSyncBatchResponse */
export interface VisitBillingSyncBatchResponse {
  /**
   * Requestedcount
   * Number of visit IDs requested
   */
  requestedCount: number;
  /**
   * Syncedcount
   * Number of visits successfully synced
   */
  syncedCount: number;
  /**
   * Skippedcount
   * Number of visits skipped because they are not completed
   */
  skippedCount: number;
  /**
   * Notfoundcount
   * Number of visit IDs not found
   */
  notFoundCount: number;
  /**
   * Failedcount
   * Number of visits that failed to sync
   */
  failedCount: number;
  /**
   * Results
   * Per-visit billing sync result
   */
  results: VisitBillingSyncItemResult[];
}

/** VisitBillingSyncByQueryResponse */
export interface VisitBillingSyncByQueryResponse {
  /** Matchedcount */
  matchedCount: number;
  /** Processedcount */
  processedCount: number;
  /** Syncedcount */
  syncedCount: number;
  /** Skippedcount */
  skippedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Failedcount */
  failedCount: number;
  /** Results */
  results: VisitBillingSyncItemResult[];
}

/** VisitBillingSyncItemResult */
export interface VisitBillingSyncItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'synced' | 'skipped' | 'not_found' | 'failed';
  /**
   * Visitstatus
   * Current visit status when available
   */
  visitStatus?: string | null;
  /** Detail */
  detail?: string | null;
}

/** VisitBulkQueryRequest */
export interface VisitBulkQueryRequest {
  /**
   * Searchquery
   * Free-text search query applied to visits
   */
  searchQuery?: string | null;
  /**
   * Sort
   * JSON:API sort string, e.g. '-start_time,visit_id'
   */
  sort?: string | null;
  /**
   * Filters
   * Filter map using query-style keys like filter[status][in]
   */
  filters?: Record<string, any>;
  /**
   * Excludedids
   * Visit IDs to exclude from the matched set before processing
   */
  excludedIds?: number[];
}

/** VisitCancelBatchResponse */
export interface VisitCancelBatchResponse {
  /**
   * Requestedcount
   * Number of visit IDs requested
   */
  requestedCount: number;
  /**
   * Cancelledcount
   * Number of visits cancelled
   */
  cancelledCount: number;
}

/** VisitCompleteBatchResponse */
export interface VisitCompleteBatchResponse {
  /**
   * Requestedcount
   * Number of visit IDs requested
   */
  requestedCount: number;
  /**
   * Completedcount
   * Number of visits newly completed
   */
  completedCount: number;
  /**
   * Skippedcount
   * Number already completed/cancelled and left unchanged
   */
  skippedCount: number;
  /**
   * Failedcount
   * Number that failed validation (e.g. no caregivers)
   */
  failedCount: number;
  /**
   * Notfoundcount
   * Number of visit IDs not found
   */
  notFoundCount: number;
  /**
   * Results
   * Per-visit completion result
   */
  results: VisitCompleteItemResult[];
}

/** VisitCompleteByQueryResponse */
export interface VisitCompleteByQueryResponse {
  /** Matchedcount */
  matchedCount: number;
  /** Processedcount */
  processedCount: number;
  /** Completedcount */
  completedCount: number;
  /** Skippedcount */
  skippedCount: number;
  /** Failedcount */
  failedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Results */
  results: VisitCompleteItemResult[];
}

/** VisitCompleteItemResult */
export interface VisitCompleteItemResult {
  /** Visitid */
  visitId: number;
  /** Status */
  status: 'completed' | 'skipped' | 'failed' | 'not_found';
  /**
   * Visitstatus
   * Current visit status when available
   */
  visitStatus?: string | null;
  /** Detail */
  detail?: string | null;
}

/**
 * VisitDateAvailability
 * Response model indicating which dates have visits
 */
export interface VisitDateAvailability {
  /**
   * Date
   * The date
   * @format date
   */
  date: string;
  /**
   * Hasvisits
   * Whether visits exist on this date
   */
  hasVisits: boolean;
  /**
   * Visitcount
   * Number of visits on this date
   */
  visitCount: number;
}

/** VisitDeleteByQueryResponse */
export interface VisitDeleteByQueryResponse {
  /** Matchedcount */
  matchedCount: number;
  /** Processedcount */
  processedCount: number;
  /** Deletedcount */
  deletedCount: number;
  /** Skippedcount */
  skippedCount: number;
  /** Notfoundcount */
  notFoundCount: number;
  /** Failedcount */
  failedCount: number;
  /** Results */
  results: VisitBatchDeleteItemResult[];
}

/** VisitFutureVisitCheckResponse */
export interface VisitFutureVisitCheckResponse {
  /**
   * Requiresconfirmation
   * Whether the frontend should ask the user to choose a scope
   */
  requiresConfirmation: boolean;
  /** Code */
  code?: 'future_visits_confirmation_required' | null;
  /** Message */
  message?: string | null;
  /** Visitid */
  visitId: number;
  /** Servicerequestid */
  serviceRequestId?: number | null;
  /**
   * Futurevisitcount
   * @default 0
   */
  futureVisitCount?: number;
  /** Targetvisitids */
  targetVisitIds?: number[];
  /** Targetvisits */
  targetVisits?: VisitFutureVisitCheckTarget[];
  /** Nextvisitstarttime */
  nextVisitStartTime?: string | null;
  /** Availablescopes */
  availableScopes?: ('single_visit' | 'all_future_visits')[];
  /** Sameslotvisitids */
  sameSlotVisitIds?: number[];
  /**
   * Sourcehasline
   * @default false
   */
  sourceHasLine?: boolean;
  /**
   * Coverswholeslot
   * @default false
   */
  coversWholeSlot?: boolean;
}

/**
 * VisitFutureVisitCheckTarget
 * One visit "this and all future visits" would reach, with its instant.
 *
 * The dashboard lists them so a coordinator can see WHICH visits a save
 * changes rather than only how many. The id alone would cost it one GET per
 * sibling to render a date, and the scope statement already carries the
 * instants - it selects them for the same-slot filter.
 */
export interface VisitFutureVisitCheckTarget {
  /** Visitid */
  visitId: number;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
}

/** VisitMinified */
export interface VisitMinified {
  /** Id */
  id: number;
  /** Servicerequestid */
  serviceRequestId?: number | null;
  /** Servicerequestlineid */
  serviceRequestLineId?: number | null;
  /**
   * Manuallyrescheduled
   * @default false
   */
  manuallyRescheduled?: boolean;
  /**
   * Manuallyrepriced
   * @default false
   */
  manuallyRepriced?: boolean;
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Completedat */
  completedAt?: string | null;
  /** Checkinat */
  checkInAt?: string | null;
  /** Status */
  status?: string | null;
  /** Paymentrequired */
  paymentRequired?: boolean | null;
  /** Outstandingamount */
  outstandingAmount?: number | null;
  /** Totalcharged */
  totalCharged?: number | null;
  /** Totalpaid */
  totalPaid?: number | null;
  /** Paidatvisit */
  paidAtVisit?: number | null;
  /** Iscollectionvisit */
  isCollectionVisit?: boolean | null;
  client?: ClientMinified | null;
  /**
   * Caregivers
   * @default []
   */
  caregivers?: CaregiverAvailabilityResponse[] | null;
}

/**
 * VisitNote
 * One visit in the notes list, with its caregiver note if it has one.
 */
export interface VisitNote {
  /** Visitid */
  visitId: number;
  /** Clientid */
  clientId: number;
  /** Clientname */
  clientName: string;
  /** Caregivers */
  caregivers?: VisitNoteCaregiver[];
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Status */
  status: string;
  /** Note */
  note?: string | null;
  flag?: CaregiverNoteFlagEnum | null;
}

/**
 * VisitNoteCaregiver
 * A caregiver assigned to the visit the note belongs to.
 *
 * Deliberately not ``CaregiverMinified``: that model is free to grow fields
 * for its own callers, and this endpoint's whole reason for existing is that
 * it does not pay for fields it does not render.
 */
export interface VisitNoteCaregiver {
  /** Caregiverid */
  caregiverId: number;
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** VisitPopulated */
export interface VisitPopulated {
  /**
   * Starttime
   * @format date-time
   */
  startTime: string;
  /**
   * Endtime
   * @format date-time
   */
  endTime: string;
  /** Completedat */
  completedAt?: string | null;
  /** Checkinat */
  checkInAt?: string | null;
  /** Remindersentat */
  reminderSentAt?: string | null;
  /** Street */
  street: string;
  /** City */
  city: string;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  status?: VisitStatusEnum | null;
  /** Canceldate */
  cancelDate?: string | null;
  /** Cancelreason */
  cancelReason?: string | null;
  /**
   * Referringdoctorid
   * Referring doctor ID at the time of visit creation
   */
  referringDoctorId?: number | null;
  /**
   * Attendingdoctorid
   * Attending doctor ID at the time of visit creation
   */
  attendingDoctorId?: number | null;
  /** Heartrate */
  heartRate?: number | null;
  /** Oxygensaturation */
  oxygenSaturation?: number | null;
  /** Respiratoryrate */
  respiratoryRate?: number | null;
  /** Co2Level */
  co2Level?: number | null;
  /** Temperature */
  temperature?: number | null;
  /** Bloodpressuresystolic */
  bloodPressureSystolic?: number | null;
  /** Bloodpressurediastolic */
  bloodPressureDiastolic?: number | null;
  /** Bloodglucose */
  bloodGlucose?: number | null;
  /** Weight */
  weight?: number | null;
  /** Height */
  height?: number | null;
  /** Bmi */
  bmi?: number | null;
  /** Painscale */
  painScale?: number | null;
  /** Fvc */
  fvc?: number | null;
  /** Fev1 */
  fev1?: number | null;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  /** Id */
  id: number;
  /** Client model with populated doctor information for visits */
  client: ClientWithDoctors;
  /** Caregivers */
  caregivers?: CaregiverWithServices[] | null;
  /** Servicerequestid */
  serviceRequestId: number;
  /** Servicerequestlineid */
  serviceRequestLineId?: number | null;
  /**
   * Manuallyrescheduled
   * @default false
   */
  manuallyRescheduled?: boolean;
  /**
   * Manuallyrepriced
   * @default false
   */
  manuallyRepriced?: boolean;
  /** Fev1Fvcratio */
  fev1FvcRatio?: number | null;
  /** Services */
  services: VisitServicePopulated[];
  /**
   * Costtotal
   * Cost of the service in Euros
   */
  costTotal?: number | null;
  /**
   * Pricetotal
   * Price of the service in Euros
   */
  priceTotal?: number | null;
  referringDoctor?: DoctorMinified | null;
  attendingDoctor?: DoctorMinified | null;
  /**
   * Attachments
   * @default []
   */
  attachments?: AttachmentBase[];
  /**
   * Createdat
   * @format date-time
   */
  createdAt: string;
  /** Updatedat */
  updatedAt?: string | null;
  /** Model for service requests response body */
  serviceRequest: ServiceRequestResponse;
  paymentContext?: PaymentContext | null;
  /**
   * Rejections
   * @default []
   */
  rejections?: VisitRejection[];
}

/** VisitQueryByCaregiversAndDates */
export interface VisitQueryByCaregiversAndDates {
  /**
   * Caregiverids
   * Caregiver IDs to filter
   */
  caregiverIds: number[];
  /**
   * Dates
   * List of dates to include
   */
  dates: string[];
}

/** VisitRejection */
export interface VisitRejection {
  /** Caregiverid */
  caregiverId: number;
  /** Caregivername */
  caregiverName: string;
  /** Reason */
  reason?: string | null;
  /**
   * Rejectedat
   * @format date-time
   */
  rejectedAt: string;
}

/**
 * VisitSeriesSkip
 * One target the series update deliberately did not touch.
 */
export interface VisitSeriesSkip {
  /** Visitid */
  visitId: number;
  /**
   * Reason
   * Why this visit was left alone
   */
  reason: 'completed' | 'off_slot_nothing_to_write';
}

/**
 * VisitSeriesUpdateResponse
 * The result of applying one edit to a visit and the rest of its series.
 *
 * `skipped` is never an error. A completed visit cannot be edited at all, and
 * a series with one behind it must still be updatable, so those are reported
 * rather than raised - everything else either applied or, if anything failed,
 * nothing did.
 */
export interface VisitSeriesUpdateResponse {
  /** The visit the edit was made on, after the update */
  visit: VisitPopulated;
  /**
   * Updatedvisitids
   * Every visit written, the edited one first
   */
  updatedVisitIds?: number[];
  /** Skipped */
  skipped?: VisitSeriesSkip[];
  /** Timeupdatedvisitids */
  timeUpdatedVisitIds?: number[];
  /** Detachedvisitids */
  detachedVisitIds?: number[];
  /**
   * Lineslotupdated
   * @default false
   */
  lineSlotUpdated?: boolean;
}

/** VisitService */
export interface VisitService {
  /** Id */
  id: number;
  /** Service */
  service: number;
  /** Iscompleted */
  isCompleted?: boolean | null;
  /** Notes */
  notes?: string | null;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
}

/** VisitServicePopulated */
export interface VisitServicePopulated {
  /** Id */
  id: number;
  /** Model representing the DB schema of a homecare service. */
  service: ServiceDb;
  /** Iscompleted */
  isCompleted?: boolean | null;
  /** Notes */
  notes?: string | null;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
}

/** VisitServiceUpdate */
export interface VisitServiceUpdate {
  /** Serviceid */
  serviceId?: number | null;
  /** Notes */
  notes?: string | null;
  /** Iscompleted */
  isCompleted?: boolean | null;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
}

/** VisitServiceUpdateOrCreate */
export interface VisitServiceUpdateOrCreate {
  /** Id */
  id?: number | null;
  /** Service */
  service: number;
  /** Notes */
  notes?: string | null;
  /** Iscompleted */
  isCompleted?: boolean | null;
  /** Cost */
  cost?: number | null;
  /** Price */
  price?: number | null;
}

/** VisitServicesPaginatedResponse */
export interface VisitServicesPaginatedResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: VisitServicePopulated[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** VisitStatusBatchRequest */
export interface VisitStatusBatchRequest {
  /**
   * Visitids
   * List of visit IDs to process
   * @minItems 1
   */
  visitIds: number[];
  /** Target status to apply to all given visits */
  status: VisitStatusEnum;
  /**
   * Cancelreason
   * Required when status is CANCELLED
   */
  cancelReason?: string | null;
}

/** VisitSummariesPaginatedResponse */
export interface VisitSummariesPaginatedResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: VisitSummaryListItem[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** VisitSummaryDownload */
export interface VisitSummaryDownload {
  /** Filename */
  filename: string;
  /**
   * Contenttype
   * @default "application/pdf"
   */
  contentType?: string;
  /** Variant */
  variant: 'client' | 'caregiver';
  /**
   * Content
   * Base64-encoded PDF content
   */
  content: string;
}

/** VisitSummaryFile */
export interface VisitSummaryFile {
  /** Variant */
  variant: 'client' | 'caregiver';
  /** Bytesize */
  byteSize?: number | null;
  /** Contenthash */
  contentHash?: string | null;
}

/** VisitSummaryListItem */
export interface VisitSummaryListItem {
  /** Summaryid */
  summaryId: number;
  /** Visitid */
  visitId: number;
  /** Clientid */
  clientId?: number | null;
  /** Clientname */
  clientName?: string | null;
  /**
   * Generatedat
   * @format date-time
   */
  generatedAt: string;
  /** Status */
  status: 'generated' | 'failed';
  /**
   * Sendcount
   * @default 0
   */
  sendCount?: number;
  /** Lastsentat */
  lastSentAt?: string | null;
  /** Createdat */
  createdAt?: string | null;
}

/** VisitSummarySend */
export interface VisitSummarySend {
  /** Sendid */
  sendId: number;
  /** Recipientemail */
  recipientEmail: string;
  /** Recipienttype */
  recipientType: 'client' | 'caregiver' | 'admin' | 'custom';
  /** Variantsent */
  variantSent: 'client' | 'caregiver';
  /** Sentby */
  sentBy?: string | null;
  /**
   * Sentat
   * @format date-time
   */
  sentAt: string;
  /** Status */
  status: 'sent' | 'failed';
  /** Error */
  error?: string | null;
  /** Messageid */
  messageId?: string | null;
}

/** VisitSummaryWithSends */
export interface VisitSummaryWithSends {
  /** Summaryid */
  summaryId: number;
  /** Visitid */
  visitId: number;
  /**
   * Generatedat
   * @format date-time
   */
  generatedAt: string;
  /** Generatedby */
  generatedBy?: string | null;
  /** Sourcehash */
  sourceHash?: string | null;
  /** Status */
  status: 'generated' | 'failed';
  /** Error */
  error?: string | null;
  /** Files */
  files?: VisitSummaryFile[];
  /** Sends */
  sends?: VisitSummarySend[];
}

/** VisitUpdate */
export interface VisitUpdate {
  /** Starttime */
  startTime?: string | null;
  /** Endtime */
  endTime?: string | null;
  /** Completedat */
  completedAt?: string | null;
  /** Checkinat */
  checkInAt?: string | null;
  /** Remindersentat */
  reminderSentAt?: string | null;
  /** Street */
  street?: string | null;
  /** City */
  city?: string | null;
  /** Postalcode */
  postalCode?: string | null;
  /** Floor */
  floor?: number | null;
  /** Geolat */
  geoLat?: number | null;
  /** Geolng */
  geoLng?: number | null;
  status?: VisitStatusEnum | null;
  /** Canceldate */
  cancelDate?: string | null;
  /** Cancelreason */
  cancelReason?: string | null;
  /**
   * Referringdoctorid
   * Referring doctor ID at the time of visit creation
   */
  referringDoctorId?: number | null;
  /**
   * Attendingdoctorid
   * Attending doctor ID at the time of visit creation
   */
  attendingDoctorId?: number | null;
  /** Heartrate */
  heartRate?: number | null;
  /** Oxygensaturation */
  oxygenSaturation?: number | null;
  /** Respiratoryrate */
  respiratoryRate?: number | null;
  /** Co2Level */
  co2Level?: number | null;
  /** Temperature */
  temperature?: number | null;
  /** Bloodpressuresystolic */
  bloodPressureSystolic?: number | null;
  /** Bloodpressurediastolic */
  bloodPressureDiastolic?: number | null;
  /** Bloodglucose */
  bloodGlucose?: number | null;
  /** Weight */
  weight?: number | null;
  /** Height */
  height?: number | null;
  /** Bmi */
  bmi?: number | null;
  /** Painscale */
  painScale?: number | null;
  /** Fvc */
  fvc?: number | null;
  /** Fev1 */
  fev1?: number | null;
  /**
   * Discountpercent
   * Discount percentage for the service
   */
  discountPercent?: number | null;
  /** Clientid */
  clientId?: number | null;
  /** Caregiverids */
  caregiverIds?: number[] | null;
  /** Servicerequestid */
  serviceRequestId?: number | null;
  /** Services */
  services?: VisitServiceUpdateOrCreate[] | null;
}

/** VisitsGetAllMinifiedPaginationResponse */
export interface VisitsGetAllMinifiedPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: VisitMinified[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

/** VisitsGetAllPaginationResponse */
export interface VisitsGetAllPaginationResponse {
  /**
   * Total
   * Total number of items matching the filters
   */
  total: number;
  /**
   * Offset
   * Current offset in the result set
   */
  offset: number;
  /**
   * Limit
   * Maximum number of items returned
   */
  limit: number;
  /**
   * Data
   * Paged data
   */
  data: VisitPopulated[];
  /**
   * Aggregates
   * Optional aggregates computed on filtered data (page and global)
   */
  aggregates?: Record<string, Record<string, number | null>> | null;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api/v1/visits-api/',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title visit
 * @version 1.0.0
 * @baseUrl /api/v1/visits-api/
 *
 *
 * Microservice for managing home care visits.
 *
 * ## Features
 * * Create, read, update, add attachments, and delete visits records
 * * Create visit services
 * * Secure endpoints with authentication and authorization
 *
 * ## Authentication
 * All endpoints require authentication using JWT tokens.
 * Admin endpoints require additional admin permissions.
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * @description Returns the health status and version of the service
     *
     * @tags Health
     * @name HealthCheckHealthGet
     * @summary Health check endpoint
     * @request GET:/health
     * @secure
     */
    healthCheckHealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  visits = {
    /**
     * @description Fetch a paginated list of visits in the given window, ordered newest first by start time. By default (`with_notes_only=true`) only visits whose caregiver note is present and not blank are returned. Pass `with_notes_only=false` to include note-less visits as well; their `note` is then `null` (a note saved as an empty string comes back as `""`, which is a different state). `status` optionally narrows the list to one visit status. This is the lean counterpart of `listVisits`, which returns the same note on a fully-populated visit (client, doctors, caregivers and services). A month-wide window is thousands of those rows for a view that renders six fields, so this endpoint returns only those fields.
     *
     * @tags Visits
     * @name ListVisitNotes
     * @summary Lists visits in a window with their caregiver notes
     * @request GET:/visits/notes
     * @secure
     */
    listVisitNotes: (
      query: {
        /**
         * Date From
         * Start of the window, compared against start_time (inclusive)
         * @format date-time
         */
        date_from: string;
        /**
         * Date To
         * End of the window, compared against start_time (inclusive)
         * @format date-time
         */
        date_to: string;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 50
         */
        limit?: number;
        /**
         * Client Id
         * Filter by client
         */
        client_id?: number | null;
        /**
         * Caregiver Id
         * Filter by an assigned caregiver
         */
        caregiver_id?: number | null;
        /**
         * With Notes Only
         * When true, only visits whose caregiver note is present and not blank. When false, note-less visits are included and their note is null
         * @default true
         */
        with_notes_only?: boolean;
        /**
         * Status
         * Filter by visit status
         */
        status?: VisitStatusEnum | null;
        /**
         * Flag
         * Filter by how the note is classified. Repeatable; a note matches if it carries any of the values given.
         */
        flag?: CaregiverNoteFlagEnum[] | null;
        /**
         * Unflagged Only
         * Restrict to notes nothing has classified yet. Cannot be combined with `flag`.
         * @default false
         */
        unflagged_only?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseVisitNote, void | HTTPValidationError>({
        path: `/visits/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Every note attached to this visit, newest first and tie-broken by note id so paging can neither drop a note nor show one twice. This is the visit panel's feed, and it is where a visit's notes now live: the visit itself no longer carries `notes`, `caregiverNotes` or `caregiverNoteFlag`. A visit can carry any number of notes, from the office, the caregiver and the doctor, and this returns all of the ones the caller may read. Which notes those are is decided by each note's audience and by the caller's scope over the visit, in the database. Two callers asking about the same visit legitimately get different pages.
     *
     * @tags Visits
     * @name ListNotesForVisit
     * @summary Lists the notes on one visit
     * @request GET:/visits/{visit_id}/notes
     * @secure
     */
    listNotesForVisit: (
      visitId: number,
      query?: {
        /**
         * Kind
         * Restrict to VISIT_NOTE or MESSAGE
         */
        kind?: NoteKindEnum | null;
        /**
         * Flag
         * Filter by how the note is classified. Repeatable; a note matches if it carries any of the values given.
         */
        flag?: CaregiverNoteFlagEnum[] | null;
        /**
         * Unflagged Only
         * Restrict to notes nothing has classified yet. Cannot be combined with `flag`.
         * @default false
         */
        unflagged_only?: boolean;
        /**
         * Unread Only
         * Restrict to notes the caller has not read and did not write
         * @default false
         */
        unread_only?: boolean;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 50
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseNote, void | HTTPValidationError>({
        path: `/visits/${visitId}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the comments visible to the caller. A caregiver sees only `CARE_TEAM` comments on visits they staff; an administrator sees all. The filtering is the policy's, not this query's.
     *
     * @tags Doctor portal
     * @name ListVisitDoctorComments
     * @summary List a visit's doctor comments
     * @request GET:/visits/{visit_id}/doctor-comments
     * @secure
     */
    listVisitDoctorComments: (visitId: number, params: RequestParams = {}) =>
      this.request<DoctorComment[], HTTPValidationError>({
        path: `/visits/${visitId}/doctor-comments`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a paginated list of visits with optional filters. You can filter by: - Search query (free text search across visits, clients, caregivers, services) - Client ID - Caregiver ID - Status (e.g., scheduled, completed, cancelled) - Start time range - Whether visits have attachments - Service IDs - Whether visits have assigned caregivers Results are sorted by `start_time` ascending by default.
     *
     * @tags Visits
     * @name ListVisits
     * @summary Lists all visits
     * @request GET:/visits
     * @secure
     */
    listVisits: (
      query?: {
        /**
         * Query
         * Free text search across visits, clients, caregivers, services, and attachments
         */
        query?: string | null;
        /**
         * Client Id
         * Filter by Client ID
         */
        client_id?: number | null;
        /**
         * Service Request Id
         * Filter by Service Request ID
         */
        service_request_id?: number | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
        /**
         * Visit Status
         * Filter by visit status (e.g. scheduled, completed, cancelled)
         */
        visit_status?: string | null;
        /**
         * Start Time From
         * Return visits starting **after or at** this datetime (ISO 8601 format)
         */
        start_time_from?: string | null;
        /**
         * Start Time To
         * Return visits starting **before or at** this datetime (ISO 8601 format)
         */
        start_time_to?: string | null;
        /**
         * Time From
         * Return visits that overlap with this time range start. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_from?: string | null;
        /**
         * Time To
         * Return visits that overlap with this time range end. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_to?: string | null;
        /**
         * Service Ids
         * Filter by Service IDs
         */
        service_ids?: number[] | null;
        /**
         * Has Attachments
         * Filter by presence of attachments (True = with attachments, False = without)
         */
        has_attachments?: boolean | null;
        /**
         * Has Assigned Caregivers
         * Filter by caregiver assignment (True = visits with caregivers, False = visits without caregivers)
         */
        has_assigned_caregivers?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "visit_id"
         */
        sort?: string | null;
        /**
         * Aggregate
         * JSON object specifying aggregations. Example: {"fields":{"costTotal":["sum","avg"],"durationMinutes":["sum"]}}
         */
        aggregate?: string | null;
        /**
         * Include Payment
         * Attach payment_context to each visit (extra queries; opt-in).
         * @default false
         */
        include_payment?: boolean;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitsGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/visits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a paginated list of visits with optional filters. You can filter by: - Search query (free text search across visits, clients, caregivers, services) - Client ID - Caregiver ID - Status (e.g., scheduled, completed, cancelled) - Start time range - Whether visits have attachments - Service IDs - Whether visits have assigned caregivers Results are sorted by `start_time` ascending by default.
     *
     * @tags Visits
     * @name ListVisitsMinified
     * @summary Lists all visits with minified schema
     * @request GET:/visits/minified
     * @secure
     */
    listVisitsMinified: (
      query?: {
        /**
         * Offset
         * Number of records to skip (for pagination)
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * Max number of records to return (for pagination)
         * @default 100
         */
        limit?: number;
        /**
         * Search Query
         * Free text search across visits, clients, caregivers, services, and attachments
         */
        search_query?: string | null;
        /**
         * Client Id
         * Filter by Client ID
         */
        client_id?: number | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
        /**
         * Visit Status
         * Filter by visit status (e.g. scheduled, completed, cancelled)
         */
        visit_status?: string | null;
        /**
         * Start Time From
         * Return visits starting **after or at** this datetime (ISO 8601 format)
         */
        start_time_from?: string | null;
        /**
         * Start Time To
         * Return visits starting **before or at** this datetime (ISO 8601 format)
         */
        start_time_to?: string | null;
        /**
         * Service Ids
         * Filter by Service IDs
         */
        service_ids?: number[] | null;
        /**
         * Has Attachments
         * Filter by presence of attachments (True = with attachments, False = without)
         */
        has_attachments?: boolean | null;
        /**
         * Has Assigned Caregivers
         * Filter by caregiver assignment (True = visits with caregivers, False = visits without caregivers)
         */
        has_assigned_caregivers?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'start_time,-visit_id'. Prefix with '-' for DESC.
         * @default "start_time"
         */
        sort?: string | null;
        /**
         * Aggregate
         * JSON object specifying aggregations. Example: {"fields":{"costTotal":["sum","avg"],"durationMinutes":["sum"]}}
         */
        aggregate?: string | null;
        /**
         * Include Payment
         * Attach payment_context to each visit (extra queries; opt-in).
         * @default false
         */
        include_payment?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitsGetAllMinifiedPaginationResponse, HTTPValidationError | void>({
        path: `/visits/minified`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a specific visit by its ID
     *
     * @tags Visits
     * @name GetVisitById
     * @summary Get visit by ID
     * @request GET:/visits/{visit_id}
     * @secure
     */
    getVisitById: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitPopulated, void | HTTPValidationError>({
        path: `/visits/${visitId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing visit
     *
     * @tags Visits
     * @name UpdateVisit
     * @summary Update an existing visit
     * @request PUT:/visits/{visit_id}
     * @secure
     */
    updateVisit: (
      visitId: number,
      data: VisitUpdate,
      query?: {
        /**
         * Override Conflicts
         * Apply an admin time change even if retained caregivers no longer cover the new window. They stay assigned but receive an actionable re-confirmation notification.
         * @default false
         */
        override_conflicts?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitPopulated, void | HTTPValidationError>({
        path: `/visits/${visitId}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an existing visit
     *
     * @tags Visits
     * @name DeleteVisit
     * @summary Delete an existing visit
     * @request DELETE:/visits/{visit_id}
     * @secure
     */
    deleteVisit: (visitId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/visits/${visitId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Delete multiple visits in a single request and return per-visit results
     *
     * @tags Visits
     * @name DeleteVisitsBatch
     * @summary Delete multiple visits
     * @request POST:/visits/delete-batch
     * @secure
     */
    deleteVisitsBatch: (data: VisitBatchIdsRequest, params: RequestParams = {}) =>
      this.request<VisitBatchDeleteResponse, HTTPValidationError | void>({
        path: `/visits/delete-batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Match visits by search/filter query, exclude selected IDs, then delete the remainder
     *
     * @tags Visits
     * @name DeleteVisitsByQuery
     * @summary Delete visits by query
     * @request POST:/visits/delete-bulk-by-query
     * @secure
     */
    deleteVisitsByQuery: (data: VisitBulkQueryRequest, params: RequestParams = {}) =>
      this.request<VisitDeleteByQueryResponse, HTTPValidationError | void>({
        path: `/visits/delete-bulk-by-query`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reconcile auto-generated billing transactions for a single completed visit
     *
     * @tags Visits
     * @name SyncVisitBilling
     * @summary Sync billing for a visit
     * @request POST:/visits/{visit_id}/billing/sync
     * @secure
     */
    syncVisitBilling: (visitId: number, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError | void>({
        path: `/visits/${visitId}/billing/sync`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reconcile auto-generated billing transactions for multiple visits. Only completed visits are synced; others are reported as skipped.
     *
     * @tags Visits
     * @name SyncVisitBillingBatch
     * @summary Sync billing for multiple visits
     * @request POST:/visits/billing/sync-bulk
     * @secure
     */
    syncVisitBillingBatch: (data: VisitBatchIdsRequest, params: RequestParams = {}) =>
      this.request<VisitBillingSyncBatchResponse, HTTPValidationError | void>({
        path: `/visits/billing/sync-bulk`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Match visits by search/filter query, exclude selected IDs, then run bulk billing sync for the remaining visits.
     *
     * @tags Visits
     * @name SyncVisitBillingByQuery
     * @summary Sync visit billing by query
     * @request POST:/visits/billing-sync-by-query
     * @secure
     */
    syncVisitBillingByQuery: (data: VisitBulkQueryRequest, params: RequestParams = {}) =>
      this.request<VisitBillingSyncByQueryResponse, HTTPValidationError | void>({
        path: `/visits/billing-sync-by-query`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change the status of multiple visits in a single request. COMPLETED reuses the per-visit completion machinery (billing sync, summary generation, notifications). CANCELLED is applied atomically via a single set-based UPDATE.
     *
     * @tags Visits
     * @name UpdateVisitsStatusBatch
     * @summary Batch change visit status (complete or cancel)
     * @request POST:/visits/status-batch
     * @secure
     */
    updateVisitsStatusBatch: (data: VisitStatusBatchRequest, params: RequestParams = {}) =>
      this.request<VisitCompleteBatchResponse | VisitCancelBatchResponse, void | HTTPValidationError>({
        path: `/visits/status-batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Match visits by search/filter query, exclude selected IDs, then complete the remainder
     *
     * @tags Visits
     * @name CompleteVisitsByQuery
     * @summary Complete visits by query
     * @request POST:/visits/complete-bulk-by-query
     * @secure
     */
    completeVisitsByQuery: (data: VisitBulkQueryRequest, params: RequestParams = {}) =>
      this.request<VisitCompleteByQueryResponse, HTTPValidationError | void>({
        path: `/visits/complete-bulk-by-query`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Checks whether a visit belongs to a service request with future visits so the frontend can decide whether to show a confirmation modal.
     *
     * @tags Visits
     * @name GetVisitFutureVisitCheck
     * @summary Check for future visits
     * @request GET:/visits/{visit_id}/future-visit-check
     * @secure
     */
    getVisitFutureVisitCheck: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitFutureVisitCheckResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/future-visit-check`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Applies one edit to a visit and to every later visit of the same recurrence, in a single transaction: either all of them are written or none are. The target set is derived server-side from the same rule as /future-visit-check, so a client cannot widen it.
     *
     * @tags Visits
     * @name UpdateVisitAndFutureVisits
     * @summary Update a visit and the rest of its series
     * @request PUT:/visits/{visit_id}/future-visits
     * @secure
     */
    updateVisitAndFutureVisits: (visitId: number, data: VisitUpdate, params: RequestParams = {}) =>
      this.request<VisitSeriesUpdateResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/future-visits`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Record a caregiver's check-in time when they arrive at the visit location
     *
     * @tags Visits
     * @name CheckInToVisit
     * @summary Check in to a visit
     * @request POST:/visits/{visit_id}/check-in
     * @secure
     */
    checkInToVisit: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitPopulated, void | HTTPValidationError>({
        path: `/visits/${visitId}/check-in`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visits
     * @name RecordVisitPayment
     * @summary Record a collected payment for a visit
     * @request POST:/visits/{visit_id}/payment
     * @secure
     */
    recordVisitPayment: (visitId: number, data: RecordPaymentRequest, params: RequestParams = {}) =>
      this.request<VisitPopulated, HTTPValidationError>({
        path: `/visits/${visitId}/payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The assigned caregiver declines **one** visit: records the rejection, unassigns them from the visit, and notifies the administrators. There is no accept. Separate from `POST /notifications/{notification_id}/action`, which stamps `action_value` on the notification row - one answer per notification. A summary covering six visits needs six answers, so the response is keyed to the visit instead, which is what it was always about.
     *
     * @tags Visits
     * @name RejectVisitAssignment
     * @summary Decline this visit's assignment
     * @request POST:/visits/{visit_id}/assignment-rejection
     * @secure
     */
    rejectVisitAssignment: (visitId: number, data: VisitAssignmentRejectionRequest, params: RequestParams = {}) =>
      this.request<VisitAssignmentRejectionResponse, HTTPValidationError>({
        path: `/visits/${visitId}/assignment-rejection`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns visit times for the given caregiver IDs and dates.
     *
     * @tags Visits
     * @name ListVisitsByCaregiversAndDates
     * @summary Get visits for caregivers on specific dates
     * @request POST:/visits/by-caregivers-and-dates
     * @secure
     */
    listVisitsByCaregiversAndDates: (data: VisitQueryByCaregiversAndDates, params: RequestParams = {}) =>
      this.request<VisitPopulated[], HTTPValidationError | void>({
        path: `/visits/by-caregivers-and-dates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns suggested visit slots (not persisted) for a client based on available caregivers matching a time slot, service IDs, and optional caregiver filters. Time slots must be provided as timezone-aware datetimes, and will be converted to UTC for comparison with caregiver availability data stored in the database.
     *
     * @tags Visits
     * @name SuggestVisitsFromAvailability
     * @summary Suggest visits based on caregiver availability
     * @request POST:/visits/suggested-from-availability
     * @secure
     */
    suggestVisitsFromAvailability: (data: SuggestedVisitsRequest, params: RequestParams = {}) =>
      this.request<SuggestedVisitGroup[], HTTPValidationError | void>({
        path: `/visits/suggested-from-availability`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate an export of visit data (runs in background).
     *
     * @tags Visits
     * @name ExportVisitData
     * @summary Export visit data
     * @request POST:/visits/export
     * @secure
     */
    exportVisitData: (
      query?: {
        /**
         * Query
         * Free text search across visits, clients, caregivers, services, and attachments
         */
        query?: string | null;
        /**
         * Client Id
         * Filter by Client ID
         */
        client_id?: number | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
        /**
         * Visit Status
         * Filter by visit status (e.g. scheduled, completed, cancelled)
         */
        visit_status?: string | null;
        /**
         * Start Time From
         * Return visits starting **after or at** this datetime (ISO 8601 format)
         */
        start_time_from?: string | null;
        /**
         * Start Time To
         * Return visits starting **before or at** this datetime (ISO 8601 format)
         */
        start_time_to?: string | null;
        /**
         * Time From
         * Return visits that overlap with this time range start. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_from?: string | null;
        /**
         * Time To
         * Return visits that overlap with this time range end. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_to?: string | null;
        /**
         * Service Ids
         * Filter by Service IDs
         */
        service_ids?: number[] | null;
        /**
         * Has Attachments
         * Filter by presence of attachments (True = with attachments, False = without)
         */
        has_attachments?: boolean | null;
        /**
         * Has Assigned Caregivers
         * Filter by caregiver assignment (True = visits with caregivers, False = visits without caregivers)
         */
        has_assigned_caregivers?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "visit_id"
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError | void>({
        path: `/visits/export`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Download a previously generated visit data export file by path.
     *
     * @tags Visits
     * @name DownloadVisitExport
     * @summary Download exported visit data CSV file
     * @request GET:/visits/export/download
     * @secure
     */
    downloadVisitExport: (
      query: {
        /**
         * File Path
         * Full path of the exported CSV file
         */
        file_path: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | HTTPValidationError>({
        path: `/visits/export/download`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of dates within the specified range, indicating which dates have visits. Useful for calendar views to show availability. Can be filtered by caregiver IDs. Each date includes a count of visits and a boolean flag.
     *
     * @tags Visits
     * @name CheckVisitsDateRange
     * @summary Check which dates have visits in a date range
     * @request GET:/visits/date-range-check
     * @secure
     */
    checkVisitsDateRange: (
      query?: {
        /**
         * From
         * Start date (inclusive)
         * @format date
         * @default "2026-10-02"
         */
        from?: string;
        /**
         * To
         * End date (inclusive)
         * @format date
         * @default "2026-10-02"
         */
        to?: string;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitDateAvailability[], void | HTTPValidationError>({
        path: `/visits/date-range-check`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists all attachments for a specific visit.
     *
     * @tags Visit Attachments
     * @name ListVisitAttachments
     * @summary List all attachments for a visit
     * @request GET:/visits/{visit_id}/attachments
     * @secure
     */
    listVisitAttachments: (
      visitId: number,
      query?: {
        /**
         * Offset
         * The number of records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitAttachmentsPaginatedResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/attachments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Adds an attachment to a specific visit. Supported file types: txt, csv, pdf, and images (jpg, jpeg, png, gif, bmp, webp). Maximum file size: 20MB.
     *
     * @tags Visit Attachments
     * @name CreateVisitAttachment
     * @summary Add an attachment to a visit
     * @request POST:/visits/{visit_id}/attachments
     * @secure
     */
    createVisitAttachment: (visitId: number, data: BodyCreateVisitAttachment, params: RequestParams = {}) =>
      this.request<AttachmentCreateResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/attachments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Downloads the content of a visit attachment.
     *
     * @tags Visit Attachments
     * @name DownloadVisitAttachment
     * @summary Download a visit attachment
     * @request GET:/visits/{visit_id}/attachments/{attachment_id}/download
     * @secure
     */
    downloadVisitAttachment: (visitId: number, attachmentId: number, params: RequestParams = {}) =>
      this.request<AttachmentWithContent, void | HTTPValidationError>({
        path: `/visits/${visitId}/attachments/${attachmentId}/download`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Changes an attachment's kind and/or description. The file itself is immutable - replacing its content means uploading a new one. Only the fields present in the body are written, so omitting `kind` leaves it alone and sending `null` clears it.
     *
     * @tags Visit Attachments
     * @name UpdateVisitAttachment
     * @summary Update how an attachment is described
     * @request PATCH:/visits/{visit_id}/attachments/{attachment_id}
     * @secure
     */
    updateVisitAttachment: (
      visitId: number,
      attachmentId: number,
      data: AttachmentUpdate,
      params: RequestParams = {}
    ) =>
      this.request<void, void | HTTPValidationError>({
        path: `/visits/${visitId}/attachments/${attachmentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes a visit attachment by its ID.
     *
     * @tags Visit Attachments
     * @name DeleteVisitAttachment
     * @summary Delete an attachment by ID
     * @request DELETE:/visits/{visit_id}/attachments/{attachment_id}
     * @secure
     */
    deleteVisitAttachment: (visitId: number, attachmentId: number, params: RequestParams = {}) =>
      this.request<void, HTTPValidationError | void>({
        path: `/visits/${visitId}/attachments/${attachmentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Add a service to a visit
     *
     * @tags Visit Services
     * @name CreateVisitServices
     * @summary Add a service to a visit
     * @request POST:/visits/{visit_id}/services
     * @secure
     */
    createVisitServices: (visitId: number, data: AddVisitService, params: RequestParams = {}) =>
      this.request<any, void | HTTPValidationError>({
        path: `/visits/${visitId}/services`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists services of a visit
     *
     * @tags Visit Services
     * @name ListVisitServices
     * @summary Lists services of a visit
     * @request GET:/visits/{visit_id}/services
     * @secure
     */
    listVisitServices: (
      visitId: number,
      query?: {
        /**
         * Offset
         * The number of records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The number of records to return
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitServicesPaginatedResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/services`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upsert (update or create) multiple visit services for a specific visit
     *
     * @tags Visit Services
     * @name BulkUpdateVisitServices
     * @summary Upsert (update or create) multiple visit services
     * @request PUT:/visits/{visit_id}/services
     * @secure
     */
    bulkUpdateVisitServices: (visitId: number, data: VisitServiceUpdateOrCreate[], params: RequestParams = {}) =>
      this.request<VisitService[], void | HTTPValidationError>({
        path: `/visits/${visitId}/services`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a visit service
     *
     * @tags Visit Services
     * @name UpdateVisitService
     * @summary Update a visit service
     * @request PUT:/visits/{visit_id}/services/{visit_service_id}
     * @secure
     */
    updateVisitService: (
      visitId: number,
      visitServiceId: number,
      data: VisitServiceUpdate,
      params: RequestParams = {}
    ) =>
      this.request<any, void | HTTPValidationError>({
        path: `/visits/${visitId}/services/${visitServiceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a visit service
     *
     * @tags Visit Services
     * @name DeleteVisitService
     * @summary Delete a visit service
     * @request DELETE:/visits/{visit_id}/services/{visit_service_id}
     * @secure
     */
    deleteVisitService: (visitId: number, visitServiceId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/visits/${visitId}/services/${visitServiceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Generates (or regenerates) the visit summary report PDFs for a visit.
     *
     * @tags Visit Summary
     * @name GenerateVisitSummary
     * @summary Generate a visit summary report
     * @request POST:/visits/{visit_id}/summary
     * @secure
     */
    generateVisitSummary: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitSummaryWithSends, void | HTTPValidationError>({
        path: `/visits/${visitId}/summary`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets the visit summary report metadata, including its send history.
     *
     * @tags Visit Summary
     * @name GetVisitSummary
     * @summary Get a visit summary report
     * @request GET:/visits/{visit_id}/summary
     * @secure
     */
    getVisitSummary: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitSummaryWithSends, void | HTTPValidationError>({
        path: `/visits/${visitId}/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Downloads the visit summary report PDF, base64-encoded. Caregivers are always served the caregiver (no-pricing) variant.
     *
     * @tags Visit Summary
     * @name DownloadVisitSummary
     * @summary Download a visit summary report
     * @request GET:/visits/{visit_id}/summary/download
     * @secure
     */
    downloadVisitSummary: (
      visitId: number,
      query?: {
        /**
         * Variant
         * @default "client"
         * @pattern ^(client|caregiver)$
         */
        variant?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitSummaryDownload, void | HTTPValidationError>({
        path: `/visits/${visitId}/summary/download`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Emails the visit summary report PDF to one or more recipients.
     *
     * @tags Visit Summary
     * @name SendVisitSummary
     * @summary Send a visit summary report
     * @request POST:/visits/{visit_id}/summary/send
     * @secure
     */
    sendVisitSummary: (visitId: number, data: SendSummaryRequest, params: RequestParams = {}) =>
      this.request<SendSummaryResponse, void | HTTPValidationError>({
        path: `/visits/${visitId}/summary/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  planningSessions = {
    /**
     * @description While a session is open, assignment notifications for the visits this planner touches are held rather than sent, and each touched visit is logged. Completing the session sends every affected caregiver ONE summary of what actually changed for them. If the planner never publishes, the session sends itself: `expiresAt` is 21:30 in their own day, or four hours from now for a session started after 17:30. `deliversAt` is when that send may actually happen - the same value unless the four-hour minimum pushed the deadline past 22:00, in which case it is 07:00 the next morning. Nothing is ever delivered between 22:00 and 07:00. Idempotent: a planner who already has an open session gets that session back, not an error. One open session per planner is a database fact (a partial unique index), so two browser tabs cannot open two.
     *
     * @tags Planning Sessions
     * @name OpenPlanningSession
     * @summary Starts a planning session, or returns the one already open
     * @request POST:/planning-sessions
     * @secure
     */
    openPlanningSession: (params: RequestParams = {}) =>
      this.request<PlanningSessionView, void>({
        path: `/planning-sessions`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns `null` when the caller has no open session - the ordinary answer, and not an error condition. TWO COUNTS, answering two different questions. They legitimately disagree, and using either one for the other's job misleads the planner. `pendingChangeCount` is how many VISITS this session has actually changed - staffing or timing net-different from what the session found when it first touched them. Not how many it touched: a visit dragged out and dragged back counts for nothing. One visit is one change however many field groups moved, so the bar should read "N visits changed". This is the number for the bar. `pendingNotifyCount` is how many CAREGIVERS would be notified if the planner published right now - one push each, computed by the same diff the flush runs against what each caregiver was last told. This is the number for the publish confirmation. It can be non-zero while `pendingChangeCount` is zero: a caregiver whose pre-session state was never notified is still owed a push even if the planner ended up changing nothing, and a confirmation reading "0" above a Publish that rings phones is the wrong way round.
     *
     * @tags Planning Sessions
     * @name GetCurrentPlanningSession
     * @summary The caller's open planning session, if any
     * @request GET:/planning-sessions/current
     * @secure
     */
    getCurrentPlanningSession: (params: RequestParams = {}) =>
      this.request<PlanningSessionView | null, void>({
        path: `/planning-sessions/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description One entry per visit whose staffing or timing is net-different from what the session found, ordered by visit start. A visit dragged out and dragged back is not in the list - and neither group is reported for a field that ended up where it started. Each entry carries at most two groups, `staffing` and `timing`, which are precisely what a caregiver gets told about. They revert independently and in any order, through the ordinary `PUT /visits/{visit_id}`: `{caregiverIds}` for staffing, `{startTime, endTime}` for timing. There is no revert endpoint, so a revert inherits conflict detection, shift validation and RLS from the path that owns them. Caregiver names are resolved here so the panel needs no second lookup. An empty caregiver list is an unassigned visit. `contested` is true when ANOTHER planning session - open or closed - has also touched the visit, so what is shown may not be this planner's own work and reverting it would overwrite the other planner's edit. Do not offer Revert on a contested visit's rows. It is a conservative signal, not a guarantee: an edit made outside any planning session leaves no trace for it to find.
     *
     * @tags Planning Sessions
     * @name GetPlanningSessionChanges
     * @summary What this session has changed so far, and what it changed it from
     * @request GET:/planning-sessions/{planning_session_id}/changes
     * @secure
     */
    getPlanningSessionChanges: (planningSessionId: number, params: RequestParams = {}) =>
      this.request<PlanningSessionChangeView[], void | HTTPValidationError>({
        path: `/planning-sessions/${planningSessionId}/changes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Diffs every visit the session touched against what each caregiver was last told, and sends one notification per caregiver who has something new to hear - nothing at all to those whose changes net out. Other administrators get one office summary; the planner who ran the session does not. The same flush the expiry sweep runs, so a plan published by hand and one published by the deadline say the same thing. `published` is `false` in one case only: every send failed, so nothing went out and the session was deliberately LEFT OPEN for the expiry sweep to retry. Still a 200 - the server state is intended, not an error - but the counts alone cannot be read as success, because 'everybody was already up to date' is also zero across the board.
     *
     * @tags Planning Sessions
     * @name CompletePlanningSession
     * @summary Publishes the plan: closes the session and sends the summaries
     * @request POST:/planning-sessions/{planning_session_id}/complete
     * @secure
     */
    completePlanningSession: (planningSessionId: number, params: RequestParams = {}) =>
      this.request<PlanningSessionFlushView, void | HTTPValidationError>({
        path: `/planning-sessions/${planningSessionId}/complete`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Closes the session and sends NOTHING. The fingerprints are untouched, so from here on each visit notifies on its own merits again. Deliberately a different call from `complete`: 'stop snoozing' and 'publish the plan' are different intentions, and only one of them notifies anybody.
     *
     * @tags Planning Sessions
     * @name DiscardPlanningSession
     * @summary Stops snoozing without publishing anything
     * @request DELETE:/planning-sessions/{planning_session_id}
     * @secure
     */
    discardPlanningSession: (planningSessionId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/planning-sessions/${planningSessionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  doctorComments = {
    /**
     * @description The same rows as the per-visit endpoint, for a SET of visits, so a screen asking which of N visits carries a comment makes one request instead of N. Scoping is the policy's, exactly as on the per-visit route.
     *
     * @tags Doctor portal
     * @name ListDoctorCommentsForVisits
     * @summary List doctor comments across several visits
     * @request GET:/doctor-comments
     * @secure
     */
    listDoctorCommentsForVisits: (
      query: {
        /**
         * Visit Ids
         * Visit ids to read
         * @maxItems 100
         * @minItems 1
         */
        visit_ids: number[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DoctorComment[], HTTPValidationError>({
        path: `/doctor-comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name DeleteVisitDoctorComment
     * @summary Remove a doctor comment
     * @request DELETE:/doctor-comments/{comment_id}
     * @secure
     */
    deleteVisitDoctorComment: (commentId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/doctor-comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  doctorInstructions = {
    /**
     * @description A caregiver sees only HANDLED instructions on visits they staff; an administrator sees all, which is how the office's queue is built (`status=PROCESSING`).
     *
     * @tags Doctor portal
     * @name ListDoctorInstructions
     * @summary List doctor instructions
     * @request GET:/doctor-instructions
     * @secure
     */
    listDoctorInstructions: (
      query?: {
        /** Visit Id */
        visit_id?: number | null;
        /** Status */
        status?: DoctorInstructionStatus | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseDoctorInstruction, HTTPValidationError>({
        path: `/doctor-instructions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description The office's answer. HANDLED is what makes the instruction visible to the caregiver. The decider is taken from the signed-in user, and an instruction can only be decided once.
     *
     * @tags Doctor portal
     * @name DecideDoctorInstruction
     * @summary Mark an instruction handled or not handled
     * @request PUT:/doctor-instructions/{instruction_id}/decision
     * @secure
     */
    decideDoctorInstruction: (instructionId: number, data: DoctorInstructionDecision, params: RequestParams = {}) =>
      this.request<DoctorInstruction, void | HTTPValidationError>({
        path: `/doctor-instructions/${instructionId}/decision`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  doctor = {
    /**
     * @description Records a comment against a visit of one of the doctor's own patients. The author is taken from the signed-in doctor, never from the body, and so is the audience: a doctor's comment is always written to `adm` and `doc`. Doctors and caregivers do not write to each other here, so a caregiver never sees it. There is no `visibility` field. It was removed along with the caregiver-visible comment, and an old client still sending one has it SILENTLY DROPPED rather than rejected - the models do not forbid extra keys - so a caller that believes it is choosing an audience is not. Recipients are pushed to: everyone in the audience except those holding the author's own role, which is why one doctor's comment never reaches another doctor.
     *
     * @tags Doctor portal
     * @name CreateVisitDoctorComment
     * @summary Leave a doctor's comment on a visit
     * @request POST:/doctor/visits/{visit_id}/comments
     * @secure
     */
    createVisitDoctorComment: (visitId: number, data: DoctorCommentCreate, params: RequestParams = {}) =>
      this.request<DoctorComment, void | HTTPValidationError>({
        path: `/doctor/visits/${visitId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name ListVisitDoctorCommentsAsDoctor
     * @summary List the doctor's own comments on a visit
     * @request GET:/doctor/visits/{visit_id}/comments
     * @secure
     */
    listVisitDoctorCommentsAsDoctor: (visitId: number, params: RequestParams = {}) =>
      this.request<DoctorComment[], HTTPValidationError>({
        path: `/doctor/visits/${visitId}/comments`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name ListDoctorCommentsForVisitsAsDoctor
     * @summary List the doctor's own comments across several visits
     * @request GET:/doctor/comments
     * @secure
     */
    listDoctorCommentsForVisitsAsDoctor: (
      query: {
        /**
         * Visit Ids
         * Visit ids to read
         * @maxItems 100
         * @minItems 1
         */
        visit_ids: number[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DoctorComment[], HTTPValidationError>({
        path: `/doctor/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name UpdateVisitDoctorComment
     * @summary Edit one of your own comments
     * @request PUT:/doctor/comments/{comment_id}
     * @secure
     */
    updateVisitDoctorComment: (commentId: number, data: DoctorCommentUpdate, params: RequestParams = {}) =>
      this.request<DoctorComment, void | HTTPValidationError>({
        path: `/doctor/comments/${commentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name DeleteVisitDoctorCommentAsDoctor
     * @summary Withdraw one of your own comments
     * @request DELETE:/doctor/comments/{comment_id}
     * @secure
     */
    deleteVisitDoctorCommentAsDoctor: (commentId: number, params: RequestParams = {}) =>
      this.request<void, void | HTTPValidationError>({
        path: `/doctor/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Files the instruction as PROCESSING. The caregiver cannot see it until the office marks it HANDLED, and the doctor cannot handle their own.
     *
     * @tags Doctor portal
     * @name CreateDoctorInstruction
     * @summary Send an instruction for an upcoming visit
     * @request POST:/doctor/instructions
     * @secure
     */
    createDoctorInstruction: (data: DoctorInstructionCreate, params: RequestParams = {}) =>
      this.request<DoctorInstruction, void | HTTPValidationError>({
        path: `/doctor/instructions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doctor portal
     * @name ListDoctorInstructionsAsDoctor
     * @summary List the doctor's own instructions
     * @request GET:/doctor/instructions
     * @secure
     */
    listDoctorInstructionsAsDoctor: (
      query?: {
        /** Visit Id */
        visit_id?: number | null;
        /** Status */
        status?: DoctorInstructionStatus | null;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaginatedResponseDoctorInstruction, HTTPValidationError>({
        path: `/doctor/instructions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Possible only while the instruction is still PROCESSING.
     *
     * @tags Doctor portal
     * @name UpdateDoctorInstruction
     * @summary Correct one of your own instructions
     * @request PUT:/doctor/instructions/{instruction_id}
     * @secure
     */
    updateDoctorInstruction: (instructionId: number, data: DoctorInstructionUpdate, params: RequestParams = {}) =>
      this.request<DoctorInstruction, void | HTTPValidationError>({
        path: `/doctor/instructions/${instructionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The same list as `/visits`, called as a doctor: row-level security narrows it to the visits of this doctor's own patients.
     *
     * @tags Visits
     * @name ListVisitsAsDoctor
     * @summary Lists the doctor's patients' visits
     * @request GET:/doctor/visits
     * @secure
     */
    listVisitsAsDoctor: (
      query?: {
        /**
         * Query
         * Free text search across visits, clients, caregivers, services, and attachments
         */
        query?: string | null;
        /**
         * Client Id
         * Filter by Client ID
         */
        client_id?: number | null;
        /**
         * Service Request Id
         * Filter by Service Request ID
         */
        service_request_id?: number | null;
        /**
         * Caregiver Ids
         * Filter by caregiver IDs
         */
        caregiver_ids?: number[] | null;
        /**
         * Visit Status
         * Filter by visit status (e.g. scheduled, completed, cancelled)
         */
        visit_status?: string | null;
        /**
         * Start Time From
         * Return visits starting **after or at** this datetime (ISO 8601 format)
         */
        start_time_from?: string | null;
        /**
         * Start Time To
         * Return visits starting **before or at** this datetime (ISO 8601 format)
         */
        start_time_to?: string | null;
        /**
         * Time From
         * Return visits that overlap with this time range start. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_from?: string | null;
        /**
         * Time To
         * Return visits that overlap with this time range end. Finds visits where the visit period includes or overlaps with the specified time (ISO 8601 format)
         */
        time_to?: string | null;
        /**
         * Service Ids
         * Filter by Service IDs
         */
        service_ids?: number[] | null;
        /**
         * Has Attachments
         * Filter by presence of attachments (True = with attachments, False = without)
         */
        has_attachments?: boolean | null;
        /**
         * Has Assigned Caregivers
         * Filter by caregiver assignment (True = visits with caregivers, False = visits without caregivers)
         */
        has_assigned_caregivers?: boolean | null;
        /**
         * Sort
         * JSON:API sorting, e.g. 'last_name,-created_at'. Prefix with '-' for DESC.
         * @default "visit_id"
         */
        sort?: string | null;
        /**
         * Aggregate
         * JSON object specifying aggregations. Example: {"fields":{"costTotal":["sum","avg"],"durationMinutes":["sum"]}}
         */
        aggregate?: string | null;
        /**
         * Include Payment
         * Attach payment_context to each visit (extra queries; opt-in).
         * @default false
         */
        include_payment?: boolean;
        /**
         * Offset
         * The records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitsGetAllPaginationResponse, HTTPValidationError | void>({
        path: `/doctor/visits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description The same visit as `/visits/{visit_id}`, called as a doctor: row-level security answers only for this doctor's own patients.
     *
     * @tags Visits
     * @name GetVisitByIdAsDoctor
     * @summary Get visit by ID as a doctor
     * @request GET:/doctor/visits/{visit_id}
     * @secure
     */
    getVisitByIdAsDoctor: (visitId: number, params: RequestParams = {}) =>
      this.request<VisitPopulated, void | HTTPValidationError>({
        path: `/doctor/visits/${visitId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  caregiverCash = {
    /**
     * No description
     *
     * @tags Visits
     * @name GetMyCaregiverCashRegister
     * @summary Current caregiver's cash-register summary (cash owed back)
     * @request GET:/caregiver-cash/me
     * @secure
     */
    getMyCaregiverCashRegister: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/caregiver-cash/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visits
     * @name GetMyCaregiverCashTransactions
     * @summary Current caregiver's cash-register transactions (collections + deposits)
     * @request GET:/caregiver-cash/me/transactions
     * @secure
     */
    getMyCaregiverCashTransactions: (
      query?: {
        /**
         * Limit
         * @default 50
         */
        limit?: number;
        /**
         * Offset
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/caregiver-cash/me/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  visitSummaries = {
    /**
     * @description Lists all generated visit summary reports.
     *
     * @tags Visit Summary
     * @name ListVisitSummaries
     * @summary List visit summary reports
     * @request GET:/visit-summaries
     * @secure
     */
    listVisitSummaries: (
      query?: {
        /**
         * Offset
         * The number of records to skip
         * @min 0
         * @default 0
         */
        offset?: number;
        /**
         * Limit
         * The max number of records to return
         * @min 1
         * @max 1000
         * @default 100
         */
        limit?: number;
        /**
         * Sort
         * JSON:API sorting, e.g. '-created_at'. Prefix with '-' for DESC.
         */
        sort?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<VisitSummariesPaginatedResponse, HTTPValidationError | void>({
        path: `/visit-summaries`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
